import { fetchContractVersionLanguage } from '~/services';
import { ContractVersion } from '~/services/fetch-vnm-terms';
import { determineLanguage } from './funnels';
import { trackError } from './tracking';

export const fetchContractLanguage = async (
  docuSignContracts: ContractVersion[],
  unsignedSolarContracts: ContractVersion[],
  showLmi?: boolean,
) => {
  const addContractVersionLanguageId = async (contractVersion: ContractVersion) => {
    try {
      // Get the language ID for the current language
      const response = await fetchContractVersionLanguage({
        contractVersionId: contractVersion.id,
        languageShortCode: determineLanguage() || 'en',
      });

      if (response?.contractVersionLanguage) {
        // Update the contract version with the new language ID
        const updatedContractVersion = {
          ...contractVersion,
          contractVersionLanguageId: response.contractVersionLanguage.id,
        };

        // Check if the update was successful
        if (updatedContractVersion.contractVersionLanguageId) {
          return updatedContractVersion;
        }
      }
    } catch (error) {
      trackError(error); // sends error to sentry
    }

    // Revert to the original state if the update was not successful
    return contractVersion;
  };

  const docusignContractsWithLanguageIds = docuSignContracts
    ? await Promise.all(docuSignContracts.map(addContractVersionLanguageId))
    : undefined;

  const solarContractsWithLanguageIds = unsignedSolarContracts
    ? await Promise.all(unsignedSolarContracts.map(addContractVersionLanguageId))
    : undefined;

  return docusignContractsWithLanguageIds && solarContractsWithLanguageIds
    ? {
        docuSignContracts: docusignContractsWithLanguageIds,
        showLmi,
        vnmSolarProjectContracts: solarContractsWithLanguageIds,
      }
    : {
        docuSignContracts,
        showLmi,
        vnmSolarProjectContracts: unsignedSolarContracts,
      };
};
